import type { StateCreator } from "zustand";
import type { CursorSlice, EditorState } from "./types";

export const createCursorSlice: StateCreator<EditorState, [], [], CursorSlice> = (
    set,
) => ({
    cursorLine: 1,
    cursorCol: 1,
    parsedDocument: null,
    parsedDocumentMap: new Map(),

    setCursorPosition: (line: number, col: number) => {
        set((s) => {
            if (s.cursorLine === line && s.cursorCol === col) return s;
            return { cursorLine: line, cursorCol: col };
        });
    },
});
